// Mock data for development

export const salesReps = [
  {
    id: '1',
    name: 'Laurel Johnstone',
    country: 'United States',
    region: null,
    intent: 'high',
    bookingUrl: 'https://meetings.hubspot.com/laurel-johnstone/book-a-meeting-laurel'
  },
  {
    id: '2',
    name: 'Suzy Pearson',
    country: 'United States',
    region: null,
    intent: 'low',
    bookingUrl: 'https://meetings.hubspot.com/suzy-pearson/book-a-meeting-suzy'
  },
  {
    id: '3',
    name: 'Philip Brady',
    country: 'EMEA (Europe, Middle East, and Africa)',
    region: 'EMEA',
    intent: null,
    bookingUrl: 'https://meetings.hubspot.com/philip-brady'
  },
  {
    id: '4',
    name: 'Duncan Mcgeoch',
    country: 'APAC (Asia-Pacific)',
    region: 'APAC',
    intent: null,
    bookingUrl: 'https://meetings.hubspot.com/duncan-mcgeoch'
  }
];

export const countries = [
  { value: 'United States', label: 'United States' },
  { value: 'EMEA (Europe, Middle East, and Africa)', label: 'EMEA (Europe, Middle East, and Africa)' },
  { value: 'APAC (Asia-Pacific)', label: 'APAC (Asia-Pacific)' }
];

export const usStates = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
  'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
  'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan',
  'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
  'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio',
  'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota',
  'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia',
  'Wisconsin', 'Wyoming'
];
